export default __webpack_public_path__ + "static/media/menu-arrow-left.3ca2dbe4.svg";